import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';

import { useAuth } from '../contexts/AuthContext';
import { resolvePostAuthPath } from '../utils/postAuthRedirect';

/**
 * فقط برای مهمان: اگر قبلاً وارد شده باشد، به مسیر next یا صفحه پیش‌فرض نقش هدایت می‌شود.
 * استثنا: کاربر چندسازمانی که هنوز سازمان فعال انتخاب نکرده — روی صفحهٔ ورود می‌ماند.
 */
const GuestRoute = ({ children }) => {
  const { isAuthenticated, loading, requiresActiveOrganization, organizations, activeOrganization, user } =
    useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (isAuthenticated) {
    const pendingOrgPick =
      requiresActiveOrganization && organizations.length > 1 && !activeOrganization?.id;
    if (!pendingOrgPick) {
      const target = resolvePostAuthPath({ location, user, activeOrganization });
      return <Navigate to={target} replace />;
    }
  }

  return children;
};

export default GuestRoute;
